import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { RecoilRoot } from "recoil";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import "@mile-meeting/design-system/tokens/token.css";
import { ToastProvider } from "hook/useToast";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  release: "release version",
  environment: process.env.REACT_APP_SENTRY_ENV,
  normalizeDepth: 6,
  integrations: [new Sentry.Integrations.Breadcrumbs({ console: true }), new BrowserTracing()],
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId={`${process.env.REACT_APP_GOOGLE_CLIENT_ID}`}>
    {/* <React.StrictMode> */}
    <RecoilRoot>
      <BrowserRouter>
        <ToastProvider>
          <App />
        </ToastProvider>
      </BrowserRouter>
    </RecoilRoot>
    {/* </React.StrictMode> */}
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
